import React from 'react';
import {
  GoogleSheetsIcon,
  IconTypeProps,
  KlaviyoIcon,
  MailchimpIcon,
  SalesForceIcon,
  SendlaneIcon,
  SlackIcon,
  WebhookIcon,
  ShopifyIcon,
  ZapierIcon,
} from '@mm/icons';
import { IntegrationTypes } from '@mm/state/model/ConnectionModel';

export const IntegrationIcon = ({
  integrationType,
  isActive,
  iconProps: outerIconProps,
}: {
  integrationType: IntegrationTypes;
  isActive: boolean;
  iconProps?: IconTypeProps;
}) => {
  const activeIconsColors = {
    default: '#1890FF',
    mailchimp: '#000000',
    zapier: '#FA541C',
    google_spreadsheet: '#21A465  ',
    klaviyo: '#262626',
    sendlane: '#ff3c78',
    shopify: '#8cb83b',
  };

  if (!integrationType) {
    return <></>;
  }

  const defaultIconProps = {
    color: isActive ? activeIconsColors[integrationType] : '#8EA1B2',
    size: 20,
  };

  const iconProps = outerIconProps || defaultIconProps;

  const componentsList = {
    default: <WebhookIcon {...iconProps} />,
    mailchimp: <MailchimpIcon {...iconProps} />,
    zapier: (
      <ZapierIcon
        style={{
          backgroundColor: isActive
            ? activeIconsColors[integrationType]
            : '#8EA1B2',
        }}
        color="white"
        size={20}
      />
    ),
    google_spreadsheet: <GoogleSheetsIcon {...iconProps} />,
    klaviyo: <KlaviyoIcon {...iconProps} />,
    salesforce: <SalesForceIcon {...iconProps} />,
    sendlane: <SendlaneIcon {...iconProps} />,
    slack: <SlackIcon {...iconProps} />,
    shopify: <ShopifyIcon {...iconProps} />,
  };

  return componentsList[integrationType] || null;
};
